import { directoryCheckOptions, ImplementedIPCMessage } from "../shared-types/datatypes";
import { FullSettingKey, KeyValueSettings } from "../shared-types/userconfigTypes";

export const doesDirectoryExist = async (dir: string, requireRead: boolean, requireWrite: boolean) : Promise<boolean> => {
  
  let opts = {
    dir,
    requireRead,
    requireWrite
  } as directoryCheckOptions;

  return new Promise(async (resolve, reject) => {
    try{
      let exists = await sendMessageSync('doesDirectoryExist', opts as directoryCheckOptions);
      resolve(exists);
    } catch (err) {
      console.error('doesDirectoryExist error:', err);
      reject(err);
    }
  });
};

export const saveSetting = async (fullSettingKey: FullSettingKey, value: KeyValueSettings[FullSettingKey]) => {
  return new Promise(async (resolve, reject) => {
    try{
      let content = await sendMessageSync('updateUserSetting', { fullSettingKey, value });
      resolve(content);
    } catch (err) {
      console.error('saveSetting error:', err);
      reject(err);
    }
  });


};

export const readAndDeleteFirstFile = async (dir: string) => {

  return new Promise(async (resolve, reject) => {
    try{
      let content = await sendMessageSync('readAndDeleteFirstFile', dir);
      resolve(content);
    } catch (err) {
      console.error('doesDirectoryExist error:', err);
      reject(err);
    }
  });
}

  // Send a message and wait for a response from the main process (synchronous-style using promises)
export const sendMessageSync = async <Return = any>(message: ImplementedIPCMessage, payload?: number | object | string): Promise<Return> => {
    if (window && (window as any).electron) {
      if (['updateUserSetting', 'getAllUserSettings'].includes(message)) {
        console.log('sendMessageSync:', message, payload)

      }
      // console.log('sendMessageSync:', message)
      // Invoke the main process and return a promise that resolves with the response 
      let ret = await (window as any).electron.invoke('toMainSync', {message, payload});
      if (['getAllUserSettings'].includes(message)) {
        console.log(`sendMessageSync ${message} response:`)
        console.dir(ret)
      }

      return ret
    } else {
      // throw new Error('Not running inside Electron!');
      // console.log('Not running inside Electron!');
    }
  }


    // Send message to the main process
  export const sendMessage = (message: string) => {
      if (window && (window as any).electron) {
        if (window && (window as any).electron) {
        (window as any).electron.send('toMain', message);
        }
      }
    }
  
    // Receive message from the main process
    export const onMessage = (callback: (message: string) => void): void => {
      if (window && (window as any).electron) {
        (window as any).electron.receive('fromMain', callback);
      }
    }